var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx } from "react/jsx-runtime";
import { SvgIconProvider } from "../SvgIcon/SvgIconContext";
import { TopBarProvider } from "./TopBarContext";
import TopBar from "./TopBar";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import PartialPageFallback from "_shared/ErrorBoundaryFallbacks/PartialPageFallback";
window.addEventListener("DOMContentLoaded", () => {
  const root = document.getElementById("top-bar-react-root");
  if (!root) throw new Error('Could not find DOM element with id "top-bar-react-root"');
  const topBarContextValue = JSON.parse(root.dataset.topbarcontext);
  const isLogin = JSON.parse(root.dataset.islogin);
  ReactDOM.createRoot(root).render(/* @__PURE__ */jsx(ErrorBoundary, {
    FallbackComponent: PartialPageFallback,
    children: /* @__PURE__ */jsx(SvgIconProvider, {
      children: /* @__PURE__ */jsx(TopBarProvider, {
        value: __spreadProps(__spreadValues({}, topBarContextValue), {
          isLogin
        }),
        children: /* @__PURE__ */jsx(TopBar, {})
      })
    })
  }));
});